import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { fetchJson } from '@/lib/api';

export const useUploadResume = () => {
  const { push } = useToast();

  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      return await fetchJson<{
        fileName: string;
        filePath: string;
        text: string;
      }>('/api/profile/resume', {
        body: formData,
        method: 'POST',
      });
    },
    onError: (error: Error) => push(error.message || 'Upload failed', 'error'),
  });
};
